// extracted by mini-css-extract-plugin
module.exports = {"googleDrivePicker":"googleDrivePicker__kAdhH"};